// Centralized test IDs for Lafarge Permits app
export const AUTH = {
  loginButton: 'login-google-btn',
  logoutButton: 'logout-btn',
  callbackLoader: 'auth-callback-loader',
};

export const LAYOUT = {
  sidebar: 'sidebar-nav',
  sidebarToggle: 'sidebar-toggle',
  offlineIndicator: 'offline-indicator',
  userMenu: 'user-menu',
};

export const NAV = {
  dashboard: 'nav-dashboard',
  permits: 'nav-permits',
  permitNew: 'nav-permit-new',
  sites: 'nav-sites',
  users: 'nav-users',
  help: 'nav-help',
  bugs: 'nav-bugs',
};

export const DASHBOARD = {
  statTotal: 'stat-total',
  statDrafts: 'stat-drafts',
  statSubmitted: 'stat-submitted',
  statApproved: 'stat-approved',
  recentList: 'recent-permits-list',
  newPermitCta: 'dashboard-new-permit-cta',
};

export const PERMITS = {
  list: 'permits-list',
  row: (id) => `permit-row-${id}`,
  filterType: 'filter-type',
  filterSite: 'filter-site',
  filterStatus: 'filter-status',
  filterMine: 'filter-mine',
  newButton: 'new-permit-button',
  emptyState: 'permits-empty-state',
};

export const PERMIT_FORM = {
  typeSelector: (t) => `permit-type-${t}`,
  inputTitre: 'permit-titre',
  inputSite: 'permit-site',
  inputLieu: 'permit-lieu',
  inputDescription: 'permit-description',
  inputDateDebut: 'permit-date-debut',
  inputDateFin: 'permit-date-fin',
  inputEntreprise: 'permit-entreprise',
  inputIntervenants: 'permit-intervenants',
  inputRisques: 'permit-risques',
  inputMesures: 'permit-mesures',
  inputEpi: 'permit-epi',
  extraField: (k) => `permit-extra-${k}`,
  submitDraft: 'permit-submit-draft',
  submitSubmit: 'permit-submit-submit',
  backButton: 'permit-back-button',
};

export const PERMIT_DETAIL = {
  container: 'permit-detail',
  numero: 'permit-numero',
  status: 'permit-status',
  pdfButton: 'permit-pdf-button',
  duplicateButton: 'permit-duplicate-button',
  deleteButton: 'permit-delete-button',
  submitButton: 'permit-action-submit',
  reviseButton: 'permit-action-revise',
  approveButton: 'permit-action-approve',
  rejectButton: 'permit-action-reject',
  closeButton: 'permit-action-close',
  signatureCanvas: 'signature-canvas',
  signatureClear: 'signature-clear',
  signatureValidate: 'signature-validate',
  signatureRole: 'signature-role',
};

export const HELP = {
  tabTutorials: 'help-tab-tutorials',
  tabDocs: 'help-tab-docs',
  tabRgpd: 'help-tab-rgpd',
  tabVersion: 'help-tab-version',
  bugForm: 'bug-form',
  bugTitre: 'bug-titre',
  bugDescription: 'bug-description',
  bugType: 'bug-type',
  bugSubmit: 'bug-submit',
};
